export enum ContributionType {
  UnKnown = -1,
  NoContribution = 1,
  Percentage = 2,
  DollarAmount = 3,
  EEPaysFlatAmount = 4,
}
export enum PayPeriod {
  Monthly = 1,
  SemiMonthly = 2,
  BiWeekly = 3,
  Weekly = 4,
}
export enum EmployeContributionType {
  AnyPlan = 2,
  LowestCostPlan = 3,
  SelectedPlan = 1,
}
